export default __webpack_public_path__ + "static/media/xls.3d2b63f2.svg";